import { Button } from "@/components/ui/button";
import { Lock, Crown } from "lucide-react";

interface PremiumLockProps {
  title: string;
  description: string;
}

export default function PremiumLock({ title, description }: PremiumLockProps) {
  const handleUpgrade = () => {
    const element = document.getElementById('cta');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <div className="absolute inset-0 bg-gray-100 bg-opacity-75 rounded-xl z-10 flex items-center justify-center">
      <div className="text-center bg-white p-8 rounded-xl shadow-lg max-w-md">
        <Lock className="text-amber-400 text-4xl mb-4 mx-auto" />
        <h4 className="text-xl font-semibold text-gray-900 mb-2">{title}</h4>
        <p className="text-gray-600 mb-4">{description}</p>
        <Button
          onClick={handleUpgrade}
          className="bg-gradient-to-r from-blue-600 to-purple-600 text-white px-6 py-2 font-semibold"
        >
          <Crown className="w-4 h-4 mr-2" />
          Upgrade a Premium
        </Button>
      </div>
    </div>
  );
}
